import { Link } from 'react-router';
import ProjectFlatCard from '../../campaign/p3aksjonen/project-flat-card-with-countdown/ProjectFlatCard';
import { SectionTitle } from '../typography/Heading';
import { useTopList } from './toplist-event-hook';
import styles from './toplist-event.module.less';

export const P3PopularProjects = ({ eventId, link, linkText }) => {
    const { toplist } = useTopList(eventId);

    return (
        <section className={styles.challengeTopContainer}>
            <SectionTitle className={styles.subHeader}>Populære spleiser nå 😍</SectionTitle>
            <div className={styles.topListContainer}>
                {toplist?.map((projectId) => (
                    <ProjectFlatCard
                        key={projectId}
                        projectId={projectId}
                        category={'popular-project'}
                        action={'click'}
                        properties={{ 'project-id': projectId }}
                    />
                ))}
            </div>
            {link && linkText && (
                <Link to={link} className={styles.linkText}>
                    {linkText}
                </Link>
            )}
        </section>
    );
};

export default P3PopularProjects;
